import { Component, Input } from "@angular/core";
import { RedAsteriskComponent } from "../red-asterisk/red-asterisk.component";
import { NgIf } from "@angular/common";

@Component({
    selector: "app-form-label",
    templateUrl: "./form-label.component.html",
    styleUrls: ["./form-label.component.scss"],
    standalone: true,
    imports: [NgIf, RedAsteriskComponent],
})
export class FormLabelComponent {
  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
}
